import { formatNumberCoords } from '../utils/functions';
const boltonCoords = [
  53.64559752100133,
  -2.438056631789143,
  53.6408146655336,
  -2.4485279757832834,
  53.627786266417964,
  -2.449214621291096,
  53.624528537978065,
  -2.458827658400471,
  53.623815876359394,
  -2.453677817091877,
  53.62045602378041,
  -2.460544272170002,
  53.62228870379692,
  -2.4636341769551584,
  53.62086329288301,
  -2.471015616164143,
  53.6171977294932,
  -2.4734188754414865,
  53.62524118756297,
  -2.5050045688008615,
  53.60745610259178,
  -2.5522491363944866,
  53.598492428743135,
  -2.560832205242143,
  53.59370423269265,
  -2.573191824382768,
  53.61134949691739,
  -2.595968975253029,
  53.59281059744935,
  -2.627726329989357,
  53.589651927778,
  -2.625560760498047,
  53.58822554891654,
  -2.596092904541021,
  53.56168737374823,
  -2.5586291483959522,
  53.5395108976294,
  -2.558376660019226,
  53.52277747346421,
  -2.533657421737976,
  53.52951245139594,
  -2.5151179930270384,
  53.539204857774386,
  -2.5067065855563353,
  53.52748768919787,
  -2.446110119491882,
  53.54187315135861,
  -2.4371837278903197,
  53.52712614705894,
  -2.3525717500971677,
  53.53600293650483,
  -2.3414137605952146,
  53.54548986079654,
  -2.341928744726074,
  53.55360446701721,
  -2.3721329662601542,
  53.55656175330444,
  -2.3547951671878886,
  53.56828688816701,
  -2.360974976758201,
  53.57119690990438,
  -2.371930209779729,
  53.59387702845508,
  -2.3759775615204837,
  53.59754461651827,
  -2.3672228312958743,
  53.61129523633046,
  -2.364132926510718,
  53.61635867745901,
  -2.369626090573218,
  53.62124612171994,
  -2.377694175290015,
  53.62837263029398,
  -2.378895804928687,
  53.63132468845667,
  -2.3787241435517337,
  53.6321390129845,
  -2.397091910885718,
  53.62486043003112,
  -2.400610969113257,
  53.6233842006475,
  -2.4197512126435305,
  53.62623480407577,
  -2.426960990475562,
  53.6327497460665,
  -2.425931022213843,
];

export const boltonAreaCoords = formatNumberCoords(boltonCoords);
